import React from "react";
import { Grid, Typography, Box, Button } from "@material-ui/core";
import { Localizations } from "../../../Shared/sharedTypes";
import { ImageLocalizationResource } from "../../../Shared/Auto/Interfaces/ImageLocalizationResource";

type PropTypes = {
    localizations: Localizations;
    images: Array<ImageLocalizationResource>;
};

export default function AndroidDenied({ localizations, images }: PropTypes) {
    return (
        <>
            <Grid item className="PhaseTopSection">
                <Box m={3}>
                    <Typography variant="h5">{localizations.androidDeniedMainHeader}</Typography>
                    <Typography variant="body1">{localizations.androidDeniedMainBody}</Typography>
                    <img alt="" style={{ width: "100%" }}
                        src={images.find(x => x.description == "Initial Image")?.url ?? "/images/permissionsBlockedGeneral.png"} />
                    <br />
                    <br />
                    <Typography variant="h6">{localizations.androidDeniedSitePermissionsHeader}</Typography>
                    <Typography variant="body1">{localizations.androidDeniedSitePermissionsStep1}</Typography>
                    <img
                        alt="Location of menu in Chrome for fixing site permission issues"
                        src={images.find(x => x.description == "Change Site Permissions - Step 1")?.url ?? "/images/androidLockIconLocation.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.androidDeniedSitePermissionsStep2}</Typography>
                    <br />
                    <Typography variant="body1">{localizations.androidDeniedSitePermissionsStep3}</Typography>
                    <br />
                    <img
                        alt="Actual screen for resolving site permission issues in Chrome"
                        src={images.find(x => x.description == "Change Site Permissions - Step 3")?.url ?? "/images/androidBlocked.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <br />
                    <Typography variant="h6">{localizations.androidDeniedAppPermissionsHeader}</Typography>
                    <Typography variant="body1">{localizations.androidDeniedAppPermissionsStep1}</Typography>
                    <img
                        alt="Location of menu in Chrome for fixing app permission issues"
                        src={images.find(x => x.description == "Change App Permissions - Step 1")?.url ?? "/images/androidLockIconLocation.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.androidDeniedAppPermissionsStep2}</Typography>
                    <img
                        alt="Actual screen for resolving app permission issues in Chrome"
                        src={images.find(x => x.description == "Change App Permissions - Step 2")?.url ?? "/images/androidAppPermissions.png"}
                        style={{ width: "100%" }}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">{localizations.androidDeniedFinalStep}</Typography>
                    <br />
                    <Typography variant="body1">{localizations.androidDeniedDontUseIncognito}</Typography>
                    <br />
                </Box>
            </Grid>
            <Grid item className="footer" alignContent="flex-start" justify="space-between" container direction="row">
                <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={() => window.location.reload()}
                >
                    {localizations.androidDeniedReloadPage}
                </Button>
            </Grid>
        </>
    );
}
